// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.object("Tournament", {
  id: __t.u64(),
  name: __t.string(),
  description: __t.string(),
  difficulty: __t.string(),
  entryFeeCoins: __t.i64(),
  maxParticipants: __t.u32(),
  startsAt: __t.u64(),
  endsAt: __t.u64(),
  status: __t.string(),
  prizePoolCoins: __t.i64(),
  prize1StItemId: __t.option(__t.u64()),
  prize2NdItemId: __t.option(__t.u64()),
  prize3RdItemId: __t.option(__t.u64()),
  createdAt: __t.u64(),
});


